// extracted by mini-css-extract-plugin
export default {"buttons":"_2ozKq","button":"_1rsEf","selected":"_34BXC","positioning":"_1WBPK"};